// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"274":"c2a3286e","362":"d9f78c78","416":"6121e43e","538":"8fbea772","566":"64438b07","621":"fc3901c0","884":"f6b3c2d8","930":"26967020"}[chunkId] + ".chunk.js";
};